import React, { useEffect, useState } from 'react'
import { useAlert } from '../../../../context/AlertContext';
import AppLayout from '../../../../layout/components/AppLayout';
import PortalForm from '../components/PortalForm';
import portalServices from '../portalServices';
import { CancelRounded, CheckCircle } from '@mui/icons-material';

function PortalListPage() {
    const {AppAlert} = useAlert();
    const [portalList,setPortalList] = useState(null)

    const getPortalList = () =>{
        portalServices.getList().then(res=>{
            setPortalList(res.data);
        }).catch(error=>{
            AppAlert(error.msg,"error")
        })
    }

    useEffect(()=>{
        getPortalList();
    },[]);

    return (
        <AppLayout>
            <div className='container'>
                
                <div className='row'>
                    <div className='col-md-12'>
                        <span className='float-end'><PortalForm refreshList={getPortalList} /></span>
                    </div>
                </div>
                
                <div className='row'>
                    <div className='col-md-12'>
                        <table className='table'>
                            <thead>
                                <tr>
                                    <th>Id</th>
                                    <th>Portal Id</th>
                                    <th>Display Name</th>
                                    {/* <th>API Url</th> */}
                                    <th>WhatsApp Number</th>
                                    <th>Phone Number Id</th>
                                    <th>Status</th>
                                    <th></th>
                                </tr>
                            </thead>
                            <tbody>
                                {portalList && portalList.map(portal=>
                                    <tr key={portal._id}>
                                        <td>{portal._id}</td>
                                        <td>{portal.portalId}</td>
                                        <td>{portal.displayName}</td>
                                        {/* <td>{portal.url}</td> */}
                                        <td>{portal.whatsAppNo}</td>
                                        <td>{portal.phoneNumberId}</td>
                                        <th>{portal.status == true ? <CheckCircle className='text-success' /> : <CancelRounded className='text-danger' />}</th>
                                        <td>
                                            <PortalForm refreshList={getPortalList} data={portal} />
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </AppLayout>
    )
}

export default PortalListPage